import { css } from 'styled-components';
import * as Breakpoints from './breakpoints';
/*
|------------------------------------------------------------------------------
| Mobile landscape
|------------------------------------------------------------------------------
*/
export const mobileLandscapeAndLarger = (...args) => css `
    @media ${Breakpoints.mobileLandscapeAndLarger} {
        ${css(...args)}
    }
`;
export const isMobileLandscapeAndLarger = () => {
    return window.matchMedia(Breakpoints.mobileLandscapeAndLarger).matches;
};
/*
|------------------------------------------------------------------------------
| Tablet portrait
|------------------------------------------------------------------------------
*/
export const tabletPortraitAndLarger = (...args) => css `
    @media ${Breakpoints.tabletPortraitAndLarger} {
        ${css(...args)}
    }
`;
export const isTabletPortraitAndLarger = () => {
    return window.matchMedia(Breakpoints.tabletPortraitAndLarger).matches;
};
/*
|------------------------------------------------------------------------------
| Tablet landscape
|------------------------------------------------------------------------------
*/
export const tabletLandscapeAndLarger = (...args) => css `
    @media ${Breakpoints.tabletLandscapeAndLarger} {
        ${css(...args)}
    }
`;
export const isTabletLandscapeAndLarger = () => {
    return window.matchMedia(Breakpoints.tabletLandscapeAndLarger).matches;
};
/*
|------------------------------------------------------------------------------
| Laptop
|------------------------------------------------------------------------------
*/
export const laptopAndLarger = (...args) => css `
    @media ${Breakpoints.laptopAndLarger} {
        ${css(...args)}
    }
`;
export const isLaptopAndLarger = () => {
    return window.matchMedia(Breakpoints.laptopAndLarger).matches;
};
export const isXl = () => {
    return window.matchMedia(Breakpoints.laptopAndLarger).matches;
};
/*
|------------------------------------------------------------------------------
| Custom: at least one larger than landscape
|------------------------------------------------------------------------------
*/
export const customAtLeastOneLargerThanLandscape = (...args) => css `
    @media ${Breakpoints.customAtLeastOneLargerThanLandscape} {
        ${css(...args)}
    }
`;
export const isCustomAtLeastOneLargerThanLandscape = () => {
    return window.matchMedia(Breakpoints.customAtLeastOneLargerThanLandscape).matches;
};
export const breakPointToCSSFunction = (breakpoint) => {
    switch (breakpoint) {
        case 'laptopAndLarger':
            return laptopAndLarger;
        case 'tabletLandscapeAndLarger':
            return tabletLandscapeAndLarger;
        case 'tabletPortraitAndLarger':
            return tabletPortraitAndLarger;
        case 'mobileLandscapeAndLarger':
            return mobileLandscapeAndLarger;
        case 'customAtLeastOneLargerThanLandscape':
            return customAtLeastOneLargerThanLandscape;
        default:
            return css;
    }
};
